export enum Roles {

    superAdmin = 'Super Admin',
    admin = 'Admin',
    manager = 'Manager',
    supplier = 'Supplier',
    supervisor = 'Supervisor',
    customer = 'Customer',
    siteUser = 'Site User',
}